import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes.ts";
import type { PivotReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import type { DrillDownArgs } from "../DrillDownArgs.ts";
import SmartViewPivotContainer from "./SmartViewPivotContainer";

interface Props {
  widget: SmartViewWidget;
  data: PivotReportConfigurationForRunning;
  onDrillDown: (args: DrillDownArgs) => void;
}

const SmartViewPivotWidget = ({ data, widget, onDrillDown }: Props) => {
  return <SmartViewPivotContainer data={data} widget={widget} onDrillDown={onDrillDown} />;
};

export default SmartViewPivotWidget;
